var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 4.00027C24 1.8984 22.1024 0 20 0H4C1.8976 0 0 1.8984 0 4.00027V19.9997C0 22.1016 1.8976 24 4.00027 24H12V14.9333H9.06667V10.9333H12V9.37493C12 6.6872 14.0181 4.26667 16.5 4.26667H19.7333V8.26667H16.5C16.1461 8.26667 15.7333 8.69627 15.7333 9.33973V10.9333H19.7333V14.9333H15.7333V24H20C22.1024 24 24 22.1016 24 19.9997V4.00027Z",
    fill: "#777081"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookLogo);
export default __webpack_public_path__ + "static/media/facebook-logo.3bc8d0ba.svg";
export { ForwardRef as ReactComponent };